<template lang="html">
  <div class="splash-screen">
    <div class="full-bg" />
  </div>
</template>
<script>
import {
  getDataDetailTableItem as getDataDetailTableDinein
} from '@/api/setting'
export default {
  data() {
    return {
      form: {
        item: []
      },
      cart: {},
      detail_table: {
        table: '',
        table_detail: {},
        total_guest: 1
      },
      previousTable: {},
      previousService: '',
      previousStoreId: ''
    }
  },
  mounted() {
    this.setDineIn()
  },
  methods: {
    async setDineIn() {
      try {
        const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
        if (LOCAL_DATA_CART) {
          this.cart = JSON.parse(LOCAL_DATA_CART)
        }
        const PREVIOUS_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
        if (PREVIOUS_TABLE) {
          this.previousTable = JSON.parse(PREVIOUS_TABLE)
        }
        const PREVIOUS_SERVICE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type')
        if (PREVIOUS_SERVICE) {
          this.previousService = JSON.parse(PREVIOUS_SERVICE)
        }
        const PREVIOUS_STORE_ID = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')
        if (PREVIOUS_STORE_ID) {
          this.previousStoreId = Number(PREVIOUS_STORE_ID)
        }

        if (!this.$isEmpty(this.$route.params)) {
          if (!this.$isEmpty(this.cart)) {
            if (this.previousService === 'DINE-IN' && this.previousStoreId === Number(this.$route.params.store_id)) {
              this.form = { ...this.cart }
            } else if (this.previousStoreId === Number(this.$route.params.store_id)) {
              this.form.item = this.cart.item
            }
          }

          if (!this.$isEmpty(this.previousTable)) {
            if (
              typeof this.previousTable.table !== 'undefined' &&
              typeof this.$route.params.no_table !== 'undefined' &&
              this.previousTable.table === this.$route.params.no_table
            ) {
              this.detail_table.table = this.previousTable.table
              this.detail_table.table_detail = this.previousTable.table_detail
            } else {
              await this.getTable(this.$route.params.no_table, this.$route.query.table)
              this.detail_table.table = this.$route.params.no_table
            }
          } else {
            await this.getTable(this.$route.params.no_table, this.$route.query.table)
            this.detail_table.table = this.$route.params.no_table
          }

          const obj = {
            url_id: this.$route.params.url_id,
            id: this.$route.params.store_id
          }

          this.$store.dispatch('saveCartV2', this.form)
          this.$store.dispatch('saveTableV2', this.detail_table)
          this.$store.dispatch('saveSelectedType', 'DINE-IN')
          await this.$store.dispatch('fetchOutlet', obj)
          await this.$store.dispatch('saveSelectedId', Number(this.$route.params.store_id))

          // Jika semua proses berhasil, baru push ke splash_dinein
          this.$router.push({ name: '_splash_dinein' }).catch(() => {})
        }
      } catch (e) {
        this.$router.push({ name: '_table_not_found' }).catch(() => {})
      }
    },
    async getTable(id, name = null) {
      try {
        let params = {}
        if (name) {
          params = { table_name: name }
        }
        const { data } = await getDataDetailTableDinein(id, params)
        this.$store.state.loading_axios = false
        this.detail_table.table_detail = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
        throw e // Tambahkan ini agar bisa ditangkap di setDineIn
      }
    }
  }
}
</script>
<style>
  .splash-screen, .splash-screen > div, .splash-screen > div > div.full-bg{
    width: 100%;
    height: 100%;
  }
   .full-bg{
    background-color: #1FAD1F;
  }
</style>
